import { render } from "./RpcServer.vue?vue&type=template&id=390f4cba&scoped=true"
import script from "./RpcServer.vue?vue&type=script&lang=js"
export * from "./RpcServer.vue?vue&type=script&lang=js"

import "./RpcServer.vue?vue&type=style&index=0&id=390f4cba&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390f4cba"]])

export default __exports__